(function ($)
  { "use strict"
  

/* 1. Proloder */
    $(window).on('load', function () {
      $('#preloader-active').delay(450).fadeOut('slow');
      $('body').delay(400).css({
        'overflow': 'visible'
      });
    });

/* 2. sticky And Scroll UP */
    $(window).on('scroll', function () {
      var scroll = $(window).scrollTop();
      if (scroll < 400) {
        $(".header-sticky").removeClass("sticky-bar");
        $('#back-top').fadeOut(500);
      } else {
        $(".header-sticky").addClass("sticky-bar");
        $('#back-top').fadeIn(500);
      }
    });

  // Scroll Up
    $('#back-top a').on("click", function () {
      $('body,html').animate({
        scrollTop: 0
      }, 800);
      return false;
    });
  

/* 3. slick Nav */
// mobile_menu
$(document).ready(function() {
    // Check if SlickNav is available
    if (typeof $.fn.slicknav === 'undefined') {
        console.error('❌ SlickNav plugin not loaded!');
        return;
    }
    
    var menu = $('ul#navigation');
    if(menu.length){
        menu.slicknav({
            prependTo: ".mobile_menu",
            closedSymbol: '+',
            openedSymbol:'-'
        });
        console.log('✅ SlickNav initialized successfully for', menu.length, 'navigation menu(s)');
    } else {
        console.error('❌ Navigation menu (#navigation) not found');
    }
});





/* 4. Testimonial Active (Owl Carousel)*/
var testimonial = $('.h1-testimonial-active');
if(testimonial.length){
    testimonial.owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 8000,
        autoplayHoverPause: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        navText: [
            '<i class="fa fa-arrow-left"></i>',
            '<i class="fa fa-arrow-right"></i>'
        ],
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false
            },
            500: {
                items: 1,
                nav: false,
                dots: true
            },
            600: {
                items: 1,
                nav: false,
                dots: true
            },
            1024: {
                items: 1,
                nav: false,
                dots: true
            }
        }
    });
}

  
/* 6. Nice Selectorp  */
  //var nice_Select = $('select');
  //  if(nice_Select.length){
  //    nice_Select.niceSelect();
  //  }






/* 7. data-background */
    $("[data-background]").each(function () {
      $(this).css("background-image", "url(" + $(this).attr("data-background") + ")")
      });


/* 10. WOW active - REMOVED (unused dead code) */
// WOW.js was not actually used in / - removed for performance

//// 11. ---- Mailchimp js --------//  
//    function mailChimp() {
//      $('#mc_embed_signup').find('form').ajaxChimp();
//    }
//    mailChimp();


// 12 Pop Up Img & Video - Using GLightbox (modern replacement for magnific-popup)
// GLightbox is auto-initialized in webpack bundle for all .glightbox and .popup-video elements
// No manual initialization needed - GLightbox handles everything automatically

/* 13. counterUp*/
    // $('.counter').counterUp({
    //   delay: 10,
    //   time: 3000
    // });

/* 14. Datepicker */
  // $('#datepicker1').datepicker();

// 15. Time Picker
  // $('#timepicker').timepicker();

//16. Overlay
  // $(".snake").snakeify({
  //   speed: 200
  // });


//17.  Progress barfiller
  // $('#bar1').barfiller();
  // $('#bar2').barfiller();
  // $('#bar3').barfiller();
  // $('#bar4').barfiller();
  // $('#bar5').barfiller();
  // $('#bar6').barfiller();




/* Main Slider Owl Carousel */
var mainSliderOwl = $('.slider-active-owl');
if(mainSliderOwl.length){
    mainSliderOwl.owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 9000,
        autoplayHoverPause: true,
        //animateOut: 'fadeOut',
        //animateIn: 'fadeIn',
        //animateIn: 'zoomIn',
        //animateOut: 'zoomOut',
        animateIn: 'jackInTheBox',    
        navText: [
            '<i class="ti-angle-left"></i>',
            '<i class="ti-angle-right"></i>'
        ],
        //responsive: {
        //    0: {
        //        items: 1,
        //        nav: false,
        //        dots: true
        //    },
        //    768: {
        //        items: 1,
        //        nav: true,
        //        dots: true
        //    },
        //    992: {
        //        items: 1,
        //        nav: true,
        //        dots: true
        //    }
        //},
        onInitialized: function(event) {
            // Delay animation to ensure carousel is fully loaded
            setTimeout(function() {
                doOwlAnimations('.slider-active-owl .owl-item.active');
            }, 100);
        },
        onChanged: function(event) {
            // Run animations when slide changes
            setTimeout(function() {
                doOwlAnimations('.slider-active-owl .owl-item.active');
            }, 50);
        }
    });
}

/* Animation function for Owl Carousel */
function doOwlAnimations(selector) {
    var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    var $elements = $(selector).find('[data-animation]');
    
    // Reset animations first
    $elements.removeClass(function(index, className) {
        return (className.match(/(^|\s)animate__\S+/g) || []).join(' ');
    }).removeClass('animation-done');
    
    // Clear any existing animation styles
    $elements.css({
        'animation-delay': '',
        '-webkit-animation-delay': '',
        'opacity': '',
        'visibility': ''
    });
    
    // Apply new animations with delay
    setTimeout(function() {
        $elements.each(function () {
            var $this = $(this);
            var $animationDelay = $this.data('delay') || '0.1s';
            var $animationType = 'animate__animated animate__' + ($this.data('animation') || 'fadeInLeft');
            
            $this.css({
                'animation-delay': $animationDelay,
                '-webkit-animation-delay': $animationDelay,
                'opacity': '1',
                'visibility': 'visible'
            });
            
            $this.addClass($animationType).one(animationEndEvents, function () {
                $this.removeClass($animationType);
                $this.addClass('animation-done');
            });
        });
    }, 10);
}

// Modal Activation
    //$('.search-switch').on('click', function () {
    //  $('.search-model-box').fadeIn(400);
    //});

    //$('.search-close-btn').on('click', function () {
    //  $('.search-model-box').fadeOut(400, function () {
    //      $('#search-input').val('');
    //  });
    //});

})(jQuery);